import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';

import '../dashboard/Dashboard.css';
import axios from 'axios';
import Loader from "../util/Loader";
import { DataGrid } from '@mui/x-data-grid';

import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import CopyAllIcon from '@mui/icons-material/CopyAll';

const baseApiUri = process.env.REACT_APP_API_URL;

export default function AssistantsAdmin() {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [newAssistantName, setNewAssistantName] = useState('');
  const navigate = useNavigate();

  const columns = [
    { field: 'id', headerName: 'ID', flex: 1 },
    {
      field: 'name',
      headerName: 'Name',
      flex: 3,
      editable: true,
    },
    {
      field: 'edit',
      headerName: 'Edit',
      renderCell: ({ row }) => (
        <strong>
          <EditOutlinedIcon
            className="App-icon-spacing App-icon-cursor"
            onClick={() => navigate(`/assistantadmin/${row.id}`)}
          />
        </strong>
      ),
    },
    {
      field: 'sandbox',
      headerName: 'Sandbox',
      renderCell: ({ row }) => (
        <strong>
          <CopyAllIcon
            className="App-icon-spacing App-icon-cursor"
            onClick={() => navigate(`/assistantadmin/${row.id}/sandbox`)}
          />
        </strong>
      ),
    },
  ];

  const loadAssistants = async () => {
    setLoading(true);
    try {
      const endpoint = `${baseApiUri}/ai/assistant?key=09848734-8745-afrt-8745-8745873487`;
      const res = await axios.get(endpoint);
      const filtered = res.data.assistants.filter(a => a.sandbox == null);
      setRows(filtered);
    } catch (error) {
      console.error('Error loading assistants:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateAssistant = async () => {
    if (!newAssistantName.trim()) return;
    try {
      const endpoint = `${baseApiUri}/ai/assistant?key=09848734-8745-afrt-8745-8745873487`;
      await axios.post(endpoint, { name: newAssistantName });
      setNewAssistantName('');
      setShowAddModal(false);
      await loadAssistants();
    } catch (error) {
      console.error('Error creating assistant:', error);
    }
  };

  useEffect(() => {
    loadAssistants();
  }, []);

  return (
    <div style={{ textAlign: "left" }}>
      <Loader open={loading} />
      <Container>
        <Box sx={{ padding: '20px' }}>
          <div className="admin-main" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h1>AI Assistants</h1>
            <Button variant="contained" onClick={() => setShowAddModal(true)}>
              + Add New Assistant
            </Button>
          </div>

          <Box sx={{ height: 500, width: '100%', backgroundColor: '#ffffff' }}>
            <DataGrid
              rows={rows}
              columns={columns}
              initialState={{
                pagination: {
                  paginationModel: { pageSize: 5 },
                },
              }}
              pageSizeOptions={[5]}
              checkboxSelection
              disableRowSelectionOnClick
            />
          </Box>
        </Box>
      </Container>

      {/* Add Assistant Modal */}
      <Dialog open={showAddModal} onClose={() => setShowAddModal(false)}>
        <DialogTitle>Add New Assistant</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Assistant Name"
            fullWidth
            variant="outlined"
            value={newAssistantName}
            onChange={(e) => setNewAssistantName(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowAddModal(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleCreateAssistant}>
            Create
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
